export const notificationTypeItems = [
    { label: 'ACH', value: 'ACH' },
    { label: 'Positive Pay & Stop Payment', value: 'Positive Pay' },
    { label: 'Wire', value: 'Wire' },
    { label: 'Admin', value: 'Admin' },
    { label: 'Accounts', value: 'Accounts' },
    { label: 'Login', value: 'Login' },
    { label: 'Transfer/Loan Payment', value: 'Transfer/Loan Payment' },
];
